import React, { useState } from "react";

import { Label, TitleH4 } from "../generic";
import { StyledBlock } from "../containers";
import { StyledTextArea } from "./styles";

export interface ITextAreaWithSub
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  readonly title?: string;
  readonly placeholder?: string;
  subtitle: string;
  rows?: number;
  resize?: number;
  maxlenght?: number;
  w?: string;
  grow?: string;
  p?: string;
  id?: string;
}

const TextAreaWithSub: React.FC<ITextAreaWithSub> = ({
  title = "",
  placeholder = "",
  subtitle = "",
  rows = 3,
  resize = "none",
  maxlenght = 2000,
  w = "100%",
  grow = "1",
  p,
  id,
  ...props
}) => {
  return (
    <StyledBlock w={w} grow={grow} p={p} id={id}>
      {title && (
        <Label bgColor="transparent" p="0" fontWeight="600">
          {title}
        </Label>
      )}
      <TitleH4>{subtitle}</TitleH4>
      <StyledTextArea
        placeholder={placeholder}
        {...props}
        rows={rows}
        maxLength={maxlenght}
      />
    </StyledBlock>
  );
};

export const useTextArea = (initial: string = "") => {
  const [value, setValue] = useState<string>(initial);

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement> | string) => {
    setValue(typeof e === "string" ? e : e.target.value);
  };

  return {
    value,
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement> | string) =>
      onChange(e)
  };
};

export default TextAreaWithSub;
